var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{attrs:{"label":_vm.$t('incidentReports.deadlyAccident'),"data-cy":"deadly"},model:{value:(_vm.value.deadly),callback:function ($$v) {_vm.$set(_vm.value, "deadly", $$v)},expression:"value.deadly"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }